import { message } from 'antd'
import DocumentsApi from '../../../api/Documents'
import { BASApi } from '../../../api/Finance/BAS'
import BAS from '../../../components/Finance/BAS/BAS'
import useSubmit from '../../../elements/Hooks/useSubmit'
import { isEmpty, pick, get, round } from 'lodash'
import { dateVal, numVal, strVal } from '../../../modules/Utils'
import moment from 'moment'
import React, { useState, useEffect } from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'

const docsApi = new DocumentsApi()

function BASCont() {
  const { list, fetching, fetch } = useFetchList(() => BASApi.list())

  const {
    visible,
    modalType,
    object: bas,
    setObject: setBas,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow: _onShow,
    onCancel: _onCancel,
    update,
    checkForm,
    isNew,
  } = useModalData(BASApi.create, BASApi.update, BASApi.remove, fetch)

  const [generating, submitGenerate] = useSubmit(BASApi.generate, true)
  const [generatedDate, setGeneratedDate] = useState({})
  const [generatedCSV, setGeneratedCSV] = useState([])

  async function onShow(data, type) {
    _onShow(data, type)
    await onGenerateCSV(data)
  }

  function onCancel(data, type) {
    _onCancel()
    setGeneratedDate({})
    setGeneratedCSV([])
  }

  async function onGenerate() {
    const d = await checkForm()
    const data = await submitGenerate(d)
    await onGenerateCSV()
    setGeneratedDate(data)
  }

  function getLines(lines, type) {
    let data = []
    lines.forEach((i) => {
      const taxSummary = get(i, 'taxSummary', [])

      const taxable = taxSummary.reduce((acc, v) => acc + numVal(v, 'net'), 0)
      const total = taxSummary.reduce((acc, v) => acc + numVal(v, 'gross'), 0)
      const totalTax = taxSummary.reduce((acc, v) => acc + numVal(v, 'tax'), 0)
      const STD = numVal(
        taxSummary.find((j) => j.type === 'STD'),
        'tax'
      )
      const CUS = numVal(
        taxSummary.find((j) => j.type === 'CUS'),
        'tax'
      )
      data.push([
        strVal(i, 'member.fn').toUpperCase(), //PARTNER
        strVal(i, 'member.tax'), //TIN
        strVal(i, 'account.code'), //ACCOUNT
        strVal(i, 'no'), //CLAIM NO
        dateVal(i, 'date').format('YYYY-MM-DD'), ///CLAIM DATE
        strVal(i, 'code'), // VOUCHER, SALSE CODE
        strVal(i, 'currency'), //CURRENCY
        round(taxable, 3), //TAXABLE
        round(STD, 3), //STD
        round(CUS, 3), //CUS
        round(totalTax, 3), // TAX TOTAL
        round(total, 3), //GROSS
      ])
    })

    return data
  }

  function getSumLine(summary, total) {
    const STD = summary.find((i) => i.type === 'STD')
    const CUS = summary.find((i) => i.type === 'CUS')

    return [
      ' ',
      ' ',
      ' ',
      ' ',
      ' ',
      ' ',
      ' ',
      numVal(total, 'net'),
      round(numVal(STD, 'tax'), 3),
      round(numVal(CUS, 'tax'), 3),
      numVal(total, 'tax'),
      numVal(total, 'gross'),
    ]
  }

  async function onGenerateCSV(report) {
    // const report = await submitGenerate(pick(bas, ['company', 'end']))
    // const report = bas
    console.log('report', { report })
    const header = [
      'PARTNER',
      'TIN',
      'ACCOUNT', // purchase contract, salesContract (only for voucher)
      'CLAIM NO',
      'CLAIM DATE',
      'VOUCHER',
      'CURRENCY',
      'TAXABLE AMT',
      'STD',
      'CUS',
      'TAX TOTAL',
      'GROSS AMT',
    ]

    let data = [header, ['Vouchers (Paid)', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' '], header]

    const vouchers = get(report, 'paid.vouchers', [])
    data = [...data, ...getLines(vouchers, 'voucher')]

    const vouchersSummary = get(report, 'paid.summary', [])
    const vouchersTotal = get(report, 'paid.total', [])
    data.push(getSumLine(vouchersSummary, vouchersTotal))

    data = [
      ...data,
      [' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
      ['Invoices (Collected)', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
      [
        'PARTNER',
        'TIN',
        'ACCOUNT', // purchase contract, salesContract (only for voucher)
        'CLAIM NO',
        'CLAIM DATE',
        'SALES CODE',
        'CURRENCY',
        'TAXABLE AMT',
        'STD',
        'CUS',
        'TAX TOTAL',
        'GROSS AMT',
      ],
    ]

    const invoices = get(report, 'collected.invoices', [])
    data = [...data, ...getLines(invoices, 'invoice')]

    const collectedSummary = get(report, 'collected.summary', [])
    const collectedTotal = get(report, 'collected.total', [])
    data.push(getSumLine(collectedSummary, collectedTotal))

    const confirmationHistory = bas?._history?.find((i) => i.action === 'confirm')

    data = [
      ...data,
      [' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
      ['Processed By', confirmationHistory?.name.fn, ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' '],
      [
        'Processed Date',
        confirmationHistory?.date ? moment(confirmationHistory?.date).format('DD MMM YYYY') : '',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
        ' ',
      ],
    ]
    setGeneratedCSV(data)

    // console.log(data)
    // setGeneratedDate(data)
  }

  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('bas', bas.status),
    [bas.status, isEmpty(bas.status)]
  )

  const [submittingOperation, submitOperation] = useSubmit(BASApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    const ObjectDB = await submitOperation({
      status: operation,
      ...pick(bas, ['_key', '_rev', '_id']),
    })
    if (ObjectDB) setBas(ObjectDB)
    hide()
  }

  return (
    <BAS
      {...{
        list,
        bas,
        fetching,
        submitting,
        visible,
        fetch,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        generatedCSV,
        update,
        modalType,
        formRef,
        onGenerate,
        generating,
        generatedDate,
        actions,
        fetchingActions,
        fetchActions,
        handleActions,
        isNew,
      }}
    />
  )
}

export default BASCont
